import { StateParamType } from "seneca-common/utils/routing/react-router-typesafe-routes/common";

import { ExpiryType } from "features/teachers/consts";

export const TeacherPlatformGatingEventRoutingType: StateParamType<
  TeacherPlatformGatingEvent,
  TeacherPlatformGatingEvent
> = {
  getPlainStateParam(value: TeacherPlatformGatingEvent) {
    return value;
  },
  getTypedStateParam(value) {
    return value as TeacherPlatformGatingEvent;
  }
};

export enum TeacherPlatformGatingEvent {
  PremiumExpiryBanner = "PremiumExpiryBanner",
  MisExpiryBanner = "MisExpiryBanner",
  SyncedClasses = "SyncedClasses",
  InviteParents = "InviteParents",
  SchoolPage = "SchoolPage",
  UserNotManaged = "UserNotManaged"
}

export const TeacherPlatformGatingEventToExpiryTypeMap: Record<
  TeacherPlatformGatingEvent,
  ExpiryType
> = {
  [TeacherPlatformGatingEvent.PremiumExpiryBanner]: ExpiryType.premium,
  [TeacherPlatformGatingEvent.MisExpiryBanner]: ExpiryType.misSync,
  [TeacherPlatformGatingEvent.SyncedClasses]: ExpiryType.misSync,
  [TeacherPlatformGatingEvent.InviteParents]: ExpiryType.misSync,
  [TeacherPlatformGatingEvent.SchoolPage]: ExpiryType.misSync,
  [TeacherPlatformGatingEvent.UserNotManaged]: ExpiryType.misSync
};
